import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ConfigProvider, theme, App as AntdApp } from 'antd';
import koKR from 'antd/locale/ko_KR';
import { routes } from './router';
// 토스트 투명도 관리 (최신: 100% → 이전: 80% → 60% → ...)
import { useToastOpacityManager } from './utils/toastOpacityManager';
import { NavigationBlockerProvider } from './contexts/NavigationBlockerContext';
import './App.css';

// Router 인스턴스 생성
const router = createBrowserRouter(routes);

function App() {
  // 토스트 투명도 관리 활성화
  useToastOpacityManager();

  // 커스텀 메시지 애니메이션 훅 (필요시 주석 해제)
  // useMessageAnimation();

  // 강제 애니메이션 적용 (필요시 주석 해제)
  // useEffect(() => {
  //   forceMessageAnimation();
  // }, []);

  return (
    <ConfigProvider
      locale={koKR}
      theme={{
        algorithm: theme.darkAlgorithm,
        token: {
          colorPrimary: '#F24822',
          colorBgBase: '#141414',
          colorBgContainer: '#1f1f1f',
          colorBgElevated: '#262626',
          colorBorder: '#303030',
          colorText: '#ffffff',
          colorTextSecondary: '#a6a6a6',
          fontFamily: '"Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
          // motion 설정 - 기본 애니메이션 비활성화
          motion: false,
        },
        components: {
          Layout: {
            bodyBg: '#141414',
            headerBg: '#1f1f1f',
            siderBg: '#000000',
          },
          Menu: {
            darkItemBg: '#000000',
            darkSubMenuItemBg: '#111111',
            darkItemSelectedBg: '#1890ff',
            darkItemHoverBg: '#1f1f1f',
          },
          Card: {
            colorBgContainer: '#1f1f1f',
          },
          Button: {
            primaryShadow: 'none',
          },
          Message: {
            colorBgBase: '#262626',
            colorTextBase: '#ffffff',
          },
          Modal: {
            contentBg: '#2a2a2a',
            headerBg: '#2a2a2a',
            titleColor: '#ffffff',
            colorText: '#d9d9d9',
            colorIcon: '#faad14',
            colorIconHover: '#ffc53d',
          },
        },
      }}
    >
      <AntdApp>
        <NavigationBlockerProvider>
          <RouterProvider router={router} />
        </NavigationBlockerProvider>
      </AntdApp>
    </ConfigProvider>
  );
}

export default App;
